/**
 * Industry Type multi-select map for Contract Manufacturer profile (Factory Details).
 * Same pattern as QA profile Primary / Sub Specialization: options as { value, label },
 * state as array of selected values, used with react-select isMulti.
 */
export const INDUSTRY_TYPE_OPTIONS = [
  'Additive Manufacturing (3D Printing)',
  'Automotive & Aerospace Components',
  'Batteries & Energy Storage Packs',
  'Casting & Foundry',
  'Cement, Concrete & Precast/ Building Materials',
  'Chemical & Petrochemicals (Toll Processing)',
  'Composites (FRP/CFPR)',
  'Cosmetic, Personal & Co-Packing (3PL)',
  'Electronics Manufacturing Service (EMS: PCB/ SMT/Box-Build)',
  'Food & Beverage Processing',
  'Glass, Ceramics, Stone & Tiles',
  'Heat Treatment Services',
  'Leather & Footwear',
  'Medical Devices & diagnostics',
  'Metals Fabrications & machining',
  'Nutraceuticals & Dietary Supplements',
  'Other Manufacturing (general)',
  'Packaging Conversion & Printing',
  'Paper, Pulp, Tissue & Stationary Conversion',
  'Pharmaceuticals & Biotech (CMO/CDMO)',
  'Plastics & Polymer Moulding',
  'Recycling & Waste Processing',
  'Rubber & Elastomer Products',
  'Semiconductor & IC Packing',
  'Sheet Metal forming & Stamping',
  'Surface Finishing & Coatings',
  'Textiles & Apparel',
  'Thermoforming /Blow/Rotational Moulding',
  'Tooling, moulds & Dies',
  'Wood working & furniture',
  'Contract Packing & co-packing',
];

/** Multi-select map: array of { value, label } for checkboxes */
export const INDUSTRY_TYPE_MAP = INDUSTRY_TYPE_OPTIONS.map((label) => ({
  value: label,
  label,
}));

export const industryTypeToSlug = (label) =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const INDUSTRY_SLUG_TO_LABEL = Object.fromEntries(
  INDUSTRY_TYPE_OPTIONS.map((label) => [industryTypeToSlug(label), label]),
);

export const industrySlugToLabel = (slug) => INDUSTRY_SLUG_TO_LABEL[String(slug || "").trim()] || null;

export const CM_INDUSTRY_BROWSE_OPTIONS = INDUSTRY_TYPE_MAP.map(({ value, label }) => ({
  slug: industryTypeToSlug(value),
  name: label,
}));

export const cmIndustryImagePath = (slug) => `/images/cm-industry-types/${slug}.png`;

export const CM_INDUSTRY_IMAGE_BY_SLUG = Object.fromEntries(
  INDUSTRY_TYPE_OPTIONS.map((label) => {
    const slug = industryTypeToSlug(label);
    return [slug, cmIndustryImagePath(slug)];
  }),
);

export default INDUSTRY_TYPE_OPTIONS;
